import { render } from "./zhendiDetail.vue?vue&type=template&id=59065dfa&scoped=true"
import script from "./zhendiDetail.vue?vue&type=script&lang=js"
export * from "./zhendiDetail.vue?vue&type=script&lang=js"

import "./zhendiDetail.vue?vue&type=style&index=0&id=59065dfa&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59065dfa"]])

export default __exports__